import React, { useState } from "react";
import { Layout, Menu, Button, Drawer } from "antd";
import "./HeaderFooter.css";
import { useLocation, useNavigate } from "react-router";
import { MenuOutlined } from "@ant-design/icons";
import logoHeader from "../../Images/LOGO BAS TRANSPARENT.png";
import logoHeaderWhite from "../../Images/LOGO BAS WHITE.png";
import useIsMobile from "../../Util/isMobile";

const { Header, Footer } = Layout;
const menuItems = [
  { key: "/", label: "HOME" },
  // { key: "/news", label: "News" },
  { key: "/our-value", label: "#IGNITE" },
  { key: "/brands", label: "OUR BRANDS" },
  // { key: "/stores", label: "STORES" },
  { key: "/partnership", label: "PARTNERSHIP" },
  { key: "/about-us", label: "ABOUT US" },
];

const MainHeader = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const [open, setOpen] = useState(false);
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  return (
    <Header
      className="header-layout"
      style={{ position: "sticky", zIndex: "1000" }}
    >
      <img
        className="header-logo"
        src={logoHeader}
        alt="PT BUMI AGUNG SUKSES"
        onClick={() => navigate("/")}
      />

      {/* Conditional Rendering for Desktop & Mobile */}
      {isMobile ? (
        <>
          <Button
            icon={<MenuOutlined />}
            type="default"
            color="red"
            variant="outlined"
            onClick={showDrawer}
          ></Button>
          <Drawer title="Menu" placement="right" onClose={onClose} open={open}>
            <Menu
              className="header-menu"
              theme="dark"
              mode="vertical"
              selectedKeys={[location.pathname]}
              onClick={({ key }) => {
                navigate(key);
                onClose(); // Close drawer after selection
              }}
              items={menuItems}
            />
          </Drawer>
        </>
      ) : (
        <Menu
          className="header-menu"
          theme="dark"
          mode="horizontal"
          selectedKeys={[location.pathname]}
          onClick={({ key }) => navigate(key)}
          items={menuItems}
        />
      )}
    </Header>
  );
};

const RedHeader = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const [open, setOpen] = useState(false);
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  return (
    <Header
      className="red-header-layout"
      style={{ position: "sticky", zIndex: "1000" }}
    >
      <img
        className="header-logo"
        src={logoHeaderWhite}
        alt="PT BUMI AGUNG SUKSES"
        onClick={() => navigate("/")}
      />
      {isMobile ? (
        <>
          <Button
            icon={<MenuOutlined />}
            type="default"
            variant="text"
            onClick={showDrawer}
          ></Button>
          <Drawer title="Menu" placement="right" onClose={onClose} open={open}>
            <Menu
              className="header-menu"
              theme="dark"
              mode="vertical"
              selectedKeys={[location.pathname]}
              onClick={({ key }) => {
                navigate(key);
                onClose(); // Close drawer after selection
              }}
              items={menuItems}
            />
          </Drawer>
        </>
      ) : (
        <Menu
          className="red-header-menu"
          theme="dark"
          mode="horizontal"
          selectedKeys={[location.pathname]}
          items={menuItems}
          onClick={({ key }) => {
            navigate(key);
          }}
        />
      )}
    </Header>
  );
};

const MainFooter = () => {
  return (
    <Footer className="footer-layout">
      <p className="footer-copyright">
        PT. Bumi Agung Sukses ©{new Date().getFullYear()}
      </p>
    </Footer>
  );
};

export { MainFooter, MainHeader, RedHeader };
